<template>
  <div class="vehicle-departure-page">
    <section class="page-hero">
      <!--div class="hero-badge">车辆离场登记</div-->
      <h2>离开码头前请先完成登记</h2>
      <p>
        车辆驾驶离码头前，输入手机号、车牌号进行登记，随行人员也需要登记。
      </p>
    </section>

    <section class="form-card">
      <van-form @submit="openConfirmDialog">
        <div class="form-block">
          <div class="field-label">手机号码</div>
          <div class="phone-row">
            <van-field
              v-model.trim="form.phone"
              name="phone"
              maxlength="11"
              clearable
              type="tel"
              placeholder="请输入11位手机号码"
              :rules="[
                { required: true, message: '请输入手机号' },
                { validator: validatePhone, message: '请输入正确的11位手机号' }
              ]"
              class="phone-field"
            />
            <van-button
              class="fetch-phone-btn"
              type="primary"
              plain
              round
              :loading="fetchingPhone"
              :disabled="fetchingPhone"
              @click.prevent="fetchPhoneNumber"
            >
              {{ fetchingPhone ? '获取中...' : '获取手机号' }}
            </van-button>
          </div>
        </div>

        <!--div class="form-block">
          <div class="field-label">登记姓名</div>
          <div class="name-panel">
            <span class="name-value">{{ displayName }}</span>
            <span class="name-tip">从当前登录信息自动带出，用于提交确认</span>
          </div>
        </div-->

        <div class="form-block">
          <div class="field-label">车牌号</div>
          <car-plate-keyboard
            :key="plateKeyboardRenderKey"
            :car-number="form.plateNumber"
            active-color="#1556c7"
            ok-btn-text="完成"
            @tap-key="handlePlateKeyboardChange"
            @tap-del="handlePlateKeyboardChange"
            @tap-ok="handlePlateKeyboardOk"
          />
          <div v-if="plateNumberError" class="plate-inline-error">{{ plateNumberError }}</div>
          <div class="field-hint">使用车牌专用键盘录入，支持普通汽车、新能源及港澳学警等特殊车牌。</div>
        </div>

        <div class="submit-wrap">
          <van-button
            round
            block
            type="primary"
            native-type="submit"
            class="submit-btn"
          >
            离场提交
          </van-button>
        </div>
      </van-form>
    </section>

    <van-popup
      v-model="showConfirmPopup"
      position="center"
      :style="{ width: '90%', maxWidth: '420px' }"
      round
    >
      <div class="custom-confirm-dialog departure-confirm-dialog">
        <div class="confirm-icon">
          <van-icon name="warning-o" color="#ffb020" size="52" />
        </div>
        <div class="confirm-title">请确认登记信息</div>
        <div class="confirm-details">
          <div class="detail-item">
            <span class="detail-label">手机号码</span>
            <span class="detail-value">{{ form.phone }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">姓名</span>
            <span class="detail-value">{{ displayName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">车牌号</span>
            <span class="detail-value">{{ form.plateNumber }}</span>
          </div>
        </div>
        <div class="confirm-actions">
          <van-button round type="default" @click="showConfirmPopup = false">
            取消
          </van-button>
          <van-button round color="#16a56f" :loading="submitting" @click="submitDeparture">
            确认提交
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showSuccessPopup"
      position="center"
      :close-on-click-overlay="false"
      :style="{ width: '86%', maxWidth: '360px' }"
      round
    >
      <div class="success-dialog">
        <div class="success-icon">
          <van-icon name="checked" color="#16a56f" size="58" />
        </div>
        <div class="success-title">提交成功</div>
        <div class="success-message">信息提交成功，您可离场</div>
        <van-button round block color="#16a56f" @click="closeSuccessPopup">
          我知道了
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import CarPlateKeyboard from 'vue-car-plate-keyboard/src/lib/carPlatePanel.vue';

export default {
  name: 'VehicleDeparture',
  components: {
    CarPlateKeyboard
  },
  data() {
    return {
      form: {
        phone: '',
        plateNumber: ''
      },
      plateKeyboardRenderKey: 0,
      plateNumberError: '',
      fetchingPhone: false,
      showConfirmPopup: false,
      showSuccessPopup: false,
      submitting: false
    };
  },
  computed: {
    currentUser() {
      try {
        return JSON.parse(localStorage.getItem('userInfo') || '{}');
      } catch (error) {
        return {};
      }
    },
    displayName() {
      return this.currentUser.name || this.currentUser.username || localStorage.getItem('username') || '未获取';
    }
  },
  mounted() {
    this.consumePhoneFromRoute();
  },
  watch: {
    '$route.query.mpPhone'() {
      this.consumePhoneFromRoute();
    },
    'form.plateNumber'(value) {
      if (value && this.plateNumberError) {
        this.plateNumberError = '';
      }
    }
  },
  methods: {
    validatePhone(value) {
      return /^1\d{10}$/.test(value || '');
    },
    validatePlateNumber(value) {
      const plate = (value || '').toUpperCase();
      const regularPlate = /^[\u4e00-\u9fa5][A-Z][A-HJ-NP-Z0-9]{5}$/;
      const newEnergyPlate = /^[\u4e00-\u9fa5][A-Z](?:[A-HJ-NP-Z0-9]{5}[DF]|[DF][A-HJ-NP-Z0-9]{5})$/;
      const specialPlate = /^[\u4e00-\u9fa5][A-Z][A-HJ-NP-Z0-9]{4}[\u4e00-\u9fa5A-Z0-9挂学警港澳领使]$/;

      return regularPlate.test(plate) || newEnergyPlate.test(plate) || specialPlate.test(plate);
    },
    validatePlateBeforeSubmit() {
      const plateNumber = (this.form.plateNumber || '').toUpperCase();

      if (!plateNumber) {
        this.plateNumberError = '请输入车牌号';
        this.$toast.fail(this.plateNumberError);
        return false;
      }

      if (!this.validatePlateNumber(plateNumber)) {
        this.plateNumberError = '请输入正确的中国车牌号';
        this.$toast.fail(this.plateNumberError);
        return false;
      }

      this.plateNumberError = '';
      this.form.plateNumber = plateNumber;
      return true;
    },
    handlePlateKeyboardChange(payload = {}) {
      this.form.plateNumber = String(payload.value || '').toUpperCase();

      if (this.plateNumberError && this.form.plateNumber) {
        this.plateNumberError = '';
      }
    },
    handlePlateKeyboardOk(payload = {}) {
      this.handlePlateKeyboardChange(payload);

      if (!payload.valid && this.form.plateNumber) {
        this.plateNumberError = '请输入正确的中国车牌号';
      }
    },
    fillPhoneFromProfile(showSuccessToast = true) {
      const phone =
        this.currentUser.phone ||
        this.currentUser.mobile ||
        this.currentUser.tel ||
        this.currentUser.telephone ||
        '';

      if (!phone) {
        return false;
      }

      this.form.phone = String(phone).replace(/\D/g, '').slice(0, 11);
      if (showSuccessToast) {
        this.$toast.success('手机号已带出');
      }

      return true;
    },
    consumePhoneFromRoute() {
      const { mpPhone, mpPhoneSource, mpPhoneError } = this.$route.query || {};

      if (mpPhone && this.validatePhone(mpPhone)) {
        this.form.phone = String(mpPhone).trim();
        this.clearPhoneBridgeQuery();
        this.$toast.success('手机号已自动填入');
        return;
      }

      if (mpPhoneError) {
        const message = decodeURIComponent(mpPhoneError);
        this.clearPhoneBridgeQuery();
        this.$toast.fail(message || '获取手机号失败');
        return;
      }

      if (mpPhoneSource === 'profile') {
        this.clearPhoneBridgeQuery();
        this.fillPhoneFromProfile(false);
      }
    },
    clearPhoneBridgeQuery() {
      const query = { ...(this.$route.query || {}) };
      delete query.mpPhone;
      delete query.mpPhoneSource;
      delete query.mpPhoneError;

      this.$router.replace({
        path: this.$route.path,
        query
      }).catch(() => {});
    },
    isMiniProgramWebView() {
      if (typeof window === 'undefined') {
        return false;
      }

      const ua = window.navigator.userAgent || '';
      const hasBridge = !!(window.wx && window.wx.miniProgram);
      return hasBridge || window.__wxjs_environment === 'miniprogram' || /miniprogram/i.test(ua);
    },
    getMiniProgramBridge() {
      if (typeof window === 'undefined' || !window.wx || !window.wx.miniProgram) {
        return null;
      }

      return window.wx.miniProgram;
    },
    requestPhoneFromMiniProgram() {
      const miniProgram = this.getMiniProgramBridge();
      if (!miniProgram || typeof miniProgram.navigateTo !== 'function') {
        return false;
      }

      const target = this.$route.fullPath || '/home/vehicle-departure';
      miniProgram.navigateTo({
        url: `/pages/phone-auth/index?target=${encodeURIComponent(target)}`
      });

      return true;
    },
    async fetchPhoneNumber() {
      if (this.fetchingPhone) {
        return;
      }

      this.fetchingPhone = true;

      try {
        if (this.isMiniProgramWebView() && this.requestPhoneFromMiniProgram()) {
          this.$toast.loading({
            message: '正在拉起微信手机号授权',
            forbidClick: true,
            duration: 1200
          });
          return;
        }

        if (this.fillPhoneFromProfile()) {
          return;
        }

        this.$toast.fail('当前环境不支持自动获取手机号，请手动输入');
      } finally {
        this.fetchingPhone = false;
      }
    },
    openConfirmDialog() {
      if (this.displayName === '未获取') {
        this.$toast.fail('当前登录信息中未找到姓名，请联系管理员补充');
        return;
      }

      if (!this.validatePlateBeforeSubmit()) {
        return;
      }

      this.showConfirmPopup = true;
    },
    async submitDeparture() {
      if (this.submitting) {
        return;
      }

      this.submitting = true;
      this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0
      });

      try {
        const payload = {
          phone: this.form.phone,
          name: this.displayName,
          plateNumber: this.form.plateNumber,
          submitTime: new Date().toISOString()
        };

        // 当前项目暂无对应后端接口，先落本地记录，保证页面流程可完整使用。
        const history = JSON.parse(localStorage.getItem('vehicleDepartureRecords') || '[]');
        history.unshift(payload);
        localStorage.setItem('vehicleDepartureRecords', JSON.stringify(history.slice(0, 50)));

        this.showConfirmPopup = false;
        this.showSuccessPopup = true;
      } catch (error) {
        this.$toast.fail('提交失败，请稍后重试');
      } finally {
        this.submitting = false;
        this.$toast.clear();
      }
    },
    closeSuccessPopup() {
      this.showSuccessPopup = false;
      this.form = {
        phone: '',
        plateNumber: ''
      };
      this.plateKeyboardRenderKey += 1;
      this.plateNumberError = '';
    }
  }
};
</script>

<style scoped>
.vehicle-departure-page {
  min-height: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.page-hero {
  padding: 20px 18px;
  border-radius: 24px;
  color: #fff;
  background: linear-gradient(135deg, #1556c7 0%, #0c3f95 100%);
  box-shadow: 0 20px 42px rgba(13, 72, 165, 0.22);
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 12px;
}

.page-hero h2 {
  font-size: 24px;
  line-height: 1.25;
  margin-bottom: 10px;
}

.page-hero p {
  font-size: 14px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.86);
}

.form-card {
  padding: 18px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(215, 229, 251, 0.95);
  box-shadow: var(--shadow-card);
}

.form-block + .form-block {
  margin-top: 18px;
}

.field-label {
  margin-bottom: 10px;
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 700;
}

.phone-row {
  display: flex;
  align-items: stretch;
  gap: 10px;
}

.phone-field {
  flex: 1;
}

.fetch-phone-btn {
  min-width: 118px;
  height: auto;
  flex-shrink: 0;
  color: #fff !important;
}

.name-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 15px 16px;
  border-radius: 18px;
  background: linear-gradient(180deg, #f6faff 0%, #eef4ff 100%);
  border: 1px solid var(--border-soft);
}

.name-value {
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 700;
}

.name-tip,
.field-hint {
  color: var(--text-muted);
  font-size: 12px;
  line-height: 1.6;
}

.field-hint {
  margin-top: 8px;
}

.plate-inline-error {
  margin-top: 8px;
  color: #ee0a24;
  font-size: 12px;
  line-height: 1.5;
}

.form-block ::v-deep .__vcp-number-box ul {
  height: 60px;
  gap: 6px;
  justify-content: space-between;
  overflow: visible;
}

.form-block ::v-deep .__vcp-number-box ul > li {
  flex: 0 0 calc((100% - 42px) / 8);
  margin-right: 0 !important;
  font-size: 22px;
  line-height: 60px;
  border-radius: 10px;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid #c7d3e6 !important;
  background: #fff;
}

.form-block ::v-deep .__vcp-number-box ul > li:nth-child(2),
.form-block ::v-deep .__vcp-number-box ul > li:last-child {
  margin-right: 0 !important;
}

.form-block ::v-deep .__vcp-number-box ul > li:first-child,
.form-block ::v-deep .__vcp-number-box ul > li:nth-child(2),
.form-block ::v-deep .__vcp-number-box ul > li:nth-child(3),
.form-block ::v-deep .__vcp-number-box ul > li:last-child {
  border-radius: 10px;
}

.form-block ::v-deep .__vcp-number-box ul > li::after {
  display: none !important;
}

.form-block ::v-deep .__vcp-number-box ul > li.active {
  border-color: #1556c7 !important;
  box-shadow: 0 0 0 2px rgba(21, 86, 199, 0.12);
}

.form-block ::v-deep .__vcp-number-box ul > li.last-blank-key {
  border-color: #d3dbe8 !important;
  background: #eef2f7;
}

.form-block ::v-deep .__vcp-number-box ul > li.last-blank-key::after {
  display: flex !important;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eef2f7;
}

.form-block ::v-deep .__vcp-keyboard-panel-bar {
  min-height: 56px;
  border-bottom: 1px solid #d8e1ef;
}

.form-block ::v-deep .__vcp-keyboard-panel-bar .close-board-btn {
  padding: 0 18px;
  font-size: 18px;
  line-height: 56px;
  font-weight: 700;
}

.form-block ::v-deep .__vcp-keyboard-panel {
  padding: 8px 8px calc(10px + env(safe-area-inset-bottom)) 8px;
  background: #dfe6f2;
  box-shadow: 0 -10px 30px rgba(15, 41, 88, 0.16);
}

.form-block ::v-deep .__vcp-keyboard-panel > ul {
  padding: 64px 0 0 0;
}

.form-block ::v-deep .__vcp-keyboard-panel > ul > li {
  height: 52px;
  margin: 0 0 8px 0;
  line-height: 52px;
  box-sizing: border-box;
}

.form-block ::v-deep .__vcp-keyboard-panel > ul > li > a {
  min-height: 52px;
  margin: 0 6px 0 0;
  font-size: 20px;
  line-height: 52px;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(15, 41, 88, 0.08);
}

.form-block ::v-deep .__vcp-keyboard-del-btn {
  width: 20%;
  min-width: 84px;
  min-height: 52px;
  bottom: 8px;
  right: 8px;
  border-radius: 12px;
}

.form-block ::v-deep .__vcp-keyboard-del-btn > a {
  font-size: 28px;
  line-height: 52px;
}

.form-block ::v-deep .__vcp-keyboard-del-btn span {
  top: 50%;
  transform: translate(-50%, -50%);
}

.submit-wrap {
  margin-top: 24px;
}

.submit-btn {
  height: 48px;
  font-size: 16px;
  font-weight: 700;
  color: #fff !important;
  background: linear-gradient(135deg, #22b36b 0%, #148a52 100%) !important;
  border: none !important;
  box-shadow: 0 14px 28px rgba(20, 138, 82, 0.22);
}

.departure-confirm-dialog {
  padding-top: 28px;
}

.confirm-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
  text-align: left;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 14px;
  border-radius: 16px;
  background: #f6f9ff;
  border: 1px solid #e1ebfb;
}

.detail-label {
  color: var(--text-secondary);
  font-size: 14px;
}

.detail-value {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 700;
  text-align: right;
  word-break: break-all;
}

.success-dialog {
  padding: 28px 22px 22px;
  text-align: center;
  background: #fff;
}

.success-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 14px;
}

.success-title {
  color: var(--text-primary);
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
}

.success-message {
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 22px;
}

@media (max-width: 767px) {
  .vehicle-departure-page {
    padding: 14px;
  }

  .page-hero,
  .form-card {
    border-radius: 20px;
  }

  .phone-row {
    align-items: flex-end;
    flex-wrap: wrap;
  }

  .fetch-phone-btn {
    min-width: 96px;
    min-height: 36px;
    padding: 0 12px;
    margin-left: auto;
    font-size: 13px;
  }

  .detail-item {
    flex-direction: column;
    gap: 6px;
  }

  .detail-value {
    text-align: left;
  }

  .form-block ::v-deep .__vcp-number-box ul {
    height: 56px;
    gap: 5px;
  }

  .form-block ::v-deep .__vcp-number-box ul > li {
    flex: 0 0 calc((100% - 35px) / 8);
    font-size: 20px;
    line-height: 56px;
  }

  .form-block ::v-deep .__vcp-keyboard-panel {
    padding: 8px 6px calc(10px + env(safe-area-inset-bottom)) 6px;
  }

  .form-block ::v-deep .__vcp-keyboard-panel > ul {
    padding-top: 62px;
  }

  .form-block ::v-deep .__vcp-keyboard-panel > ul > li {
    height: 50px;
    margin-bottom: 7px;
    line-height: 50px;
  }

  .form-block ::v-deep .__vcp-keyboard-panel > ul > li > a {
    min-height: 50px;
    margin-right: 5px;
    font-size: 19px;
    line-height: 50px;
  }

  .form-block ::v-deep .__vcp-keyboard-panel-bar {
    min-height: 54px;
  }

  .form-block ::v-deep .__vcp-keyboard-panel-bar .close-board-btn {
    font-size: 17px;
    line-height: 54px;
  }

  .form-block ::v-deep .__vcp-keyboard-del-btn {
    min-width: 78px;
    min-height: 50px;
    bottom: 7px;
    right: 6px;
  }

  .form-block ::v-deep .__vcp-keyboard-del-btn > a {
    line-height: 50px;
  }
}
</style>
